import { render } from "./viewFile.vue?vue&type=template&id=8a612776"
import script from "./viewFile.vue?vue&type=script&lang=js"
export * from "./viewFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__